import { Box, Paper, Skeleton } from '@mui/material';

export default function UserMenuSkeleton() {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'minmax(700px, 2fr) minmax(380px, 1fr)',
        gap: 2,
        height: 'calc(100vh - 72px)',
        maxHeight: 'calc(100vh - 72px)',
        boxSizing: 'border-box',
        p: 2,
        overflowX: 'auto',
        overflowY: 'hidden',
        alignItems: 'start',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          height: '100%',
          minHeight: 0,
          position: 'relative',
        }}
      >
        <Paper
          sx={{
            p: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, minWidth: 'fit-content' }}>
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
          <Box sx={{ display: 'flex', gap: 2, overflowX: 'hidden', width: '100%' }}>
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} variant="rounded" width={120} height={50} sx={{ borderRadius: 2, flexShrink: 0 }} />
            ))}
          </Box>
        </Paper>

        <Paper
          sx={{
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            p: 2,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Skeleton variant="rectangular" width="100%" height={40} />
          </Box>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
            <Box key={i} sx={{ display: 'flex', gap: 2, mb: 1 }}>
              <Skeleton variant="rectangular" width="100%" height={60} />
            </Box>
          ))}
        </Paper>
      </Box>

      {/* Right Column - Preview Skeleton */}
      <Paper
        sx={{
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <Skeleton variant="rounded" width={300} height={600} sx={{ borderRadius: 4 }} />
        </Box>
      </Paper>
    </Box>
  );
}
